import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const AuthHOC = (WrappedComponent, useCheckHook = null) => {
  return (props) => {
    const user = useSelector((state) => state.auth.user);
    const selectedPaymentMethod = useSelector(
      (state) => state?.payment?.selectedPaymentMethod
    );
    const location = useLocation();

    if (!user) {
      const redirectUrl = `/login?redirect=${encodeURIComponent(
        location.pathname + location.search
      )}`;
      return <Redirect to={redirectUrl} />;
    }
    

    if (user && user?.user?.role !== "customer" && !selectedPaymentMethod) {
      // const redirectUrl = `/payment-integration`;
      const redirectUrl = `/account-list`;
      return <Redirect to={redirectUrl} />;
    }

    // if (useCheckHook && user.role !== "customer") {
    //   useCheckHook();
    // }

    return <WrappedComponent {...props} />;
  };
};

export default AuthHOC;
